import { makeStyles } from '@material-ui/core/styles'
import { TextField } from '@mui/material'
import Button from '@mui/material/Button'
import { useState } from 'react'

const UserDetails = ({ carDetails, onSubmit }) => {
  const classes = useStyles()
  const [userDetails, setUSerDetails] = useState({
    userFullName: carDetails?.userFullName || '',
    userMobileNumber: carDetails?.userMobileNumber || '',
  })

  const handleSubmit = () => {
    onSubmit({
      ...carDetails,
      ...userDetails,
    })
  }

  const handleUserName = (event) => {
    setUSerDetails({
      ...userDetails,
      userFullName: event?.target?.value,
    })
  }

  const handleUserNumber = (event) => {
    setUSerDetails({
      ...userDetails,
      userMobileNumber: event?.target?.value,
    })
  }

  return (
    <div className={classes.mainContainer}>
      <div>
        <div className={classes.heading}>
          <span className={classes.headingContent}>Enter User Details</span>
        </div>
        <div className={classes.inputContainer}>
          <div className={classes.inputContent}>
            <TextField
              id='fullName'
              type='text'
              displayEmpty
              value={userDetails?.userFullName}
              onChange={handleUserName}
              label='Full Name'
              nameLabel='fullName'
              className={classes.inputTextField}
            ></TextField>
          </div>
        </div>
      </div>

      <div>
        <div className={classes.inputContainer}>
          <div className={classes.inputContent}>
            <TextField
              id='mobileNumber'
              type='number'
              displayEmpty
              value={userDetails.userMobileNumber}
              onChange={handleUserNumber}
              label='Mobile Number'
              nameLabel='mobileNumber'
              className={classes.inputTextField}
            ></TextField>
          </div>
        </div>
      </div>

      <div className={classes.actionsContainer}>
        <Button
          variant='contained'
          onClick={handleSubmit}
          className={classes.submitButton}
          id='Button'
        >
          Submit
        </Button>
      </div>
    </div>
  )
}

export default UserDetails
const useStyles = makeStyles({
  mainContainer: {
    padding: '10px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '10px',
    marginBottom: '132px',
  },
  heading: {
    width: '100%',
    textAlign: 'center',
    marginTop: '-25px',
  },
  inputContainer: {
    display: 'flex',
    marginBottom: '12px',
    marginTop: '10px',
    minWidth: '213px',
  },
  inputContent: {
    width: '100%',
  },
  inputTextField: {
    borderRadius: '5px !important',
    backgroundColor: 'white !important',
    fontSize: '12px !important',
    fontFamily: 'Roboto !important',
    width: '100%',
    '& input[type=number]::-webkit-outer-spin-button': {
      '-webkit-appearance': 'none',
      margin: 0,
    },
    '& input[type=number]::-webkit-inner-spin-button': {
      '-webkit-appearance': 'none',
      margin: 0,
    },
    '&  .MuiSvgIcon-root': {
      display: 'none',
    },
  },
  headingContent: {
    fontFamily: 'Roboto',
    fontSize: '16px',
    fontWeight: '400',
  },
  submitButton: {
    background: 'linear-gradient(180deg, #4DC3E3 0%, #1EA0C4 100%) !important',
    color: '#FFFFFF !important',
    fontWeight: '400 !important',
    fontSize: '12px !important',
    fontFamily: 'Roboto !important',
    borderRadius: '5px !important',
  },
})
